// RoleContext.tsx
import React, { createContext, useContext, ReactNode } from "react";
import { UserRole } from "../enum/enum";

interface RoleContextProps {
  children: ReactNode;
}

interface RoleContextValue {
  userRole: UserRole | null;
}

const RoleContext = createContext<RoleContextValue | undefined>(undefined);

export const RoleProvider: React.FC<RoleContextProps> = ({ children }) => {
  // You can get the user role from your authentication system or wherever it's stored
  const userRole: UserRole | null = /* Fetch user role */ null;

  return (
    <RoleContext.Provider value={{ userRole }}>{children}</RoleContext.Provider>
  );
};

export const useUserRole = () => {
  const context = useContext(RoleContext);
  const storedData = localStorage.getItem("Decoded");
  const context1 = storedData ? JSON.parse(storedData) : null;
  if (!context) {
    throw new Error("useUserRole must be used within a RoleProvider");
  }
  return context1 ? context1.Roles : "";
};

export const useAppRole = () => {
  const context = useContext(RoleContext);
  const storedData = localStorage.getItem("Decoded");
  const context1 = storedData ? JSON.parse(storedData) : null;

  if (!context) {
    throw new Error("useUserRole must be used within a RoleProvider");
  }
  return context1 ? context1.AppRole : "";
};
